// extracted by mini-css-extract-plugin
module.exports = {"dot":"dLIp0t","blink":"Pi6lqS"};